<div class="aem-Grid aem-Grid--12 aem-Grid--default--12">
  <div class="subscription-registration aem-GridColumn aem-GridColumn--default--12 subscription-registration-wrapper">
    <div class="full-bleed-row">
      <div class="partners-error-container">
        <div class="partner-error-content ada-focus">
          <div class="fp-container">
            <img alt="freshpass logo"
              class="col-sm-7 fresh-pass__logo-container__logo-image fresh-pass__logo align-self-center ada-focus"
              src="https://images.albertsons-media.com/is/image/ABS/freshpass-logo?$lplogo$&defaultImage=Not_Available">
          </div>
          <div class="ada-focus">
            <h1 role="heading" aria-level="1" class="partners-error-title ada-focus">
              {{errorMessage?.title}}
            </h1>
          </div>
          <div class="partners-error-detail ada-focus">
            {{errorMessage?.message}}
          </div>
          <button 
            class="btn btn-primary body-m--extra-bold partner-error-btn"
            (click)="navigateToSubscribe()">
            {{properties.partnersBanners.joinFreshpass}}
          </button>
        </div>
      </div>
    </div>
  </div>
